import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';
import { NewActivity } from '../new-activity';
import { Input } from '../input';
import { Select } from '../select';
import type { OptionItem } from '../../common/types/option-item';
import { MEET_RESULT, SATISFACTION } from '../../common/constants';
import { InputDate } from '../input-date';
import { useCreateContactMeetMutation } from '../../api/contact-api';
import { useNotification } from '../../hooks/use-notification';
import { getApiError } from '../../helpers/get-api-error';
import { useGetUserMeQuery } from '../../api/user-api';
import { ActivityTextArea } from '../activity-textarea';
import { useCreatePartnerMeetMutation } from '../../api/partner-api';
import { InputContainer, TextareaWrapper } from './style';

interface NewMeetProps {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  fullName: string;
  id: string | number;
  isPartner?: boolean;
}

export const NewMeet = ({
  show,
  setShow,
  fullName,
  id,
  isPartner
}: NewMeetProps) => {
  const notification = useNotification();
  const { data: userMe } = useGetUserMeQuery('');
  const [topic, setTopic] = useState('');
  const [result, setResult] = useState<OptionItem>({ id: '', title: '' });
  const [satisfaction, setSatisfaction] = useState<OptionItem>({
    id: '',
    title: ''
  });
  const [date, setDate] = useState('');
  const [message, setMessage] = useState('');
  const [createContactMeet] = useCreateContactMeetMutation();
  const [createPartnerMeet] = useCreatePartnerMeetMutation();
  const handleClose = () => {
    setShow(false);
    setResult({ id: '', title: '' });
    setSatisfaction({ id: '', title: '' });
    setDate('');
    setMessage('');
    setTopic('');
  };

  const handleCreateContactMeet = () => {
    createContactMeet({
      contact: id,
      text: message,
      result: result.id,
      satisfaction: satisfaction.id,
      date: date.split('/').reverse().join('-'),
      contact_meet_owner: userMe?.id || '',
      topic
    })
      .unwrap()
      .then(() => {
        notification({
          type: 'success',
          title: 'Зустріч внесено.',
          message: 'Ви успішно внесли зустріч.'
        });
        handleClose();
      })
      .catch((err) => {
        notification({
          type: 'error',
          title: 'Поилка',
          message: getApiError(err)
        });
      });
  };

  const handleCreatePartnerMeet = () => {
    createPartnerMeet({
      partner: id,
      text: message,
      result: result.id,
      satisfaction: satisfaction.id,
      date: date.split('/').reverse().join('-'),
      partner_meet_owner: userMe?.id || '',
      topic
    })
      .unwrap()
      .then(() => {
        notification({
          type: 'success',
          title: 'Зустріч внесено.',
          message: 'Ви успішно внесли зустріч.'
        });
        handleClose();
      })
      .catch((err) => {
        notification({
          type: 'error',
          title: 'Поилка',
          message: getApiError(err)
        });
      });
  };

  return (
    <NewActivity
      title="Внести персональний контакт/зустріч "
      btnTitle="Внести зустріч"
      show={show}
      onClose={handleClose}
      onSubmit={isPartner ? handleCreatePartnerMeet : handleCreateContactMeet}
      customHeight="453px"
      disabled={
        !result.id ||
        !topic ||
        !message ||
        !satisfaction.id ||
        !date ||
        date === '__/__/____'
      }
    >
      <InputContainer>
        <Input
          label={isPartner ? 'Партнер' : 'Контакт'}
          disabled
          value={fullName}
          onChange={() => {}}
        />
        <Select
          label="Результат"
          value={result}
          options={MEET_RESULT}
          setValue={setResult}
        />
        <InputDate value={date} setValue={setDate} required />
        <Select
          value={satisfaction}
          setValue={setSatisfaction}
          label="Настрій"
          options={SATISFACTION.slice(1)}
        />
        <Input
          label="Тема"
          value={topic}
          onChange={(e) => {
            setTopic(e.target.value);
          }}
          required
        />
      </InputContainer>
      <TextareaWrapper>
        <ActivityTextArea
          value={message}
          setValue={setMessage}
          placeholder="Опишіть зустріч..."
          required
        />
      </TextareaWrapper>
    </NewActivity>
  );
};
